export const environment = {
  production: true,
  environmentName: "@@{environmentName}@@",
  serviceURL: "@@{serviceURL}@@",
  auth: {
    issuer: "https://login.microsoftonline.com/@@{tenantId}@@/v2.0",
    clientId: "@@{clientId}@@",
    redirectUri: location.origin,
    postLogoutRedirectUri: location.origin,
    responseType: "code",
    scope: "openid profile email @@{clientId}@@/.default",
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
    customQueryParams: { domain_hint: "@@{domainHint}@@" },
    silent_redirect_uri: location.origin,
    silentRefreshShowIFrame: false,
    timeoutFactor: 0.5,
  },
};
